import { ProviderAccount } from '@prisma/client'
import { Button, Flex, Result } from 'antd'
import { useState } from 'react'
import { useUserContext } from '~/core/context'
import { Api } from '~/core/trpc'
import { useNango } from '~/plugins/nango/client'
import { GoogleDocConfigurationConnect } from '../../../type'

type Props = {
  account: ProviderAccount
  onSubmit: (accountUpdated: ProviderAccount) => void
}

export const StepOne: React.FC<Props> = ({ account, onSubmit }) => {
  const { session } = useUserContext()
  const nango = useNango()
  const configuration = account?.configuration as GoogleDocConfigurationConnect
  const [isConnected, setIsConnected] = useState(
    !!configuration?.nangoConnectionId,
  )
  const [accountUpdated, setAccountUpdated] = useState(account)
  const [isError, setIsError] = useState(false)
  const { mutateAsync: updateProviderAccount } =
    Api.providerAccount.update.useMutation()

  const handleConnect = async () => {
    nango
      .auth('google-docs', session?.user?.id)
      .then(async result => {
        console.log({ result })
        updateProviderAccount({
          where: { id: account.id },
          data: { configuration: { nangoConnectionId: session?.user?.id } },
        }).then(setAccountUpdated)
        setIsConnected(true)
      })
      .catch(error => {
        console.error('Unknown Error', error)
        setIsError(true)
      })
  }

  if (isError) {
    return (
      <Result
        status="error"
        title="Error connecting to your Google Account"
        extra={[
          <Button key="connect-again" onClick={() => setIsError(false)}>
            Connect again
          </Button>,
        ]}
      />
    )
  }

  return (
    <Flex vertical className="w-full" gap={16} align="center">
      {isConnected ? (
        <Result
          status="success"
          title="Successfully connected to your Google Account"
          extra={[
            <Button
              type="primary"
              key="continue"
              onClick={() => onSubmit(accountUpdated)}
            >
              Continue
            </Button>,
            <Button key="connect-again" onClick={() => setIsConnected(false)}>
              Connect again
            </Button>,
          ]}
        />
      ) : (
        <Button onClick={handleConnect} type="primary" style={{ width: '50%' }}>
          Connect to your Google Account{' '}
        </Button>
      )}
    </Flex>
  )
}
